import { Injectable } from '@angular/core';
import { UserStore } from '@models/models';

@Injectable({
    providedIn: 'root',
})
export class StoreUser {
    private userStore: UserStore = new UserStore();

    constructor() {}

    setAvatar(avatar: string | ArrayBuffer): void {
        this.userStore.avatar = avatar;
    }

    public get userStoreValue(): UserStore {
        return this.userStore;
    }
}
